import * as React from 'react';
import { Fragment } from 'react';
import { isObservableArray } from 'mobx';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import StarRating from './StarRating';
import SRRI from './SRRI';
import ChangeIndicator from './ChangeIndicator';
import Translate from './Translate';
import { StringOrNumber, IconAlignment } from '../types';
import { ShowChange } from '../models/configuration/ShowChange';
import { DataStore } from '../stores';

interface FundFactValue {
    dataStore: DataStore;
    theme?: { [property: string]: StringOrNumber };
    value: StringOrNumber | Array<StringOrNumber>;
    ui?: 'srri' | 'stars' | 'starsOutOf';
    separator?: string;
    showChange?: boolean | ShowChange;
    higherRiskLabel?: string;
    lowerRiskLabel?: string;
    alignIcon?: IconAlignment;
    upIcon?: string;
    downIcon?: string;
    noDataPlaceholder?: string;
}

export const FundFactValue: React.SFC<FundFactValue> = ({
    dataStore,
    ui,
    value,
    separator,
    showChange,
    higherRiskLabel,
    lowerRiskLabel,
    alignIcon,
    upIcon = 'FundFactChangeUpIcon.svg',
    downIcon = 'FundFactChangeDownIcon.svg',
    noDataPlaceholder,
}) => {
    if (ui === 'srri' && typeof value === 'number') {
        return (
            <SRRI
                rating={value}
                higherRiskLabel={higherRiskLabel}
                lowerRiskLabel={lowerRiskLabel}
            />
        );
    }

    if (ui === 'stars' || ui === 'starsOutOf') {
        return (
            <StarRating
                showEmptyStars={ui === 'starsOutOf'}
                rating={value as StringOrNumber}
                noDataPlaceholder={noDataPlaceholder}
            />
        );
    }
    const changeIndicator = showChange && (
        <ChangeIndicator
            dataStore={dataStore}
            value={value as number}
            alignIcon={alignIcon}
            upIcon={upIcon}
            downIcon={downIcon}
            showChange={typeof showChange !== 'boolean' && showChange}
        />
    );
    return (
        <Fragment>
            {showChange ? (
                changeIndicator
            ) : isObservableArray(value) ? (
                (value as Array<StringOrNumber>).join(separator || ', ')
            ) : (
                <Translate>{value}</Translate>
            )}
            {separator}
        </Fragment>
    );
};

export default observer(withTheme(FundFactValue));



// WEBPACK FOOTER //
// ./src/Components/FundFactValue.tsx